import { render, staticRenderFns } from "./WideStaticNotice.vue?vue&type=template&id=7c937c26&scoped=true&"
import script from "./WideStaticNotice.vue?vue&type=script&lang=ts&"
export * from "./WideStaticNotice.vue?vue&type=script&lang=ts&"
import style0 from "./WideStaticNotice.vue?vue&type=style&index=0&id=7c937c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c937c26",
  null
  
)

export default component.exports